// extracted by mini-css-extract-plugin
module.exports = {"userAgreements":"UserAgreements_userAgreements__c9a4i","userAgreementsLink":"UserAgreements_userAgreementsLink__0ln2h"};